import React from "react";
import {
  Box,
  IconButton,
  Typography,
} from "@mui/material";
import {
  makeStyles
} from "@mui/styles";
import {
  Autorenew as AutorenewIcon
} from "@mui/icons-material";
import formatNumber from "../../utils/number-formatter";

const TableTotalCount = ({ count, onUpdate }) => {
  const classes = useStyles();
  const handleUpdate = () => {
    if (!onUpdate) return
    onUpdate();
  }
  return (
    <Box className={classes.root}>
      <Typography className={classes.title}>Найдено:</Typography>
      <Typography className={classes.count}>{ formatNumber(count, { decimals: 0 }) }</Typography>
      <IconButton className={classes.button} onClick={handleUpdate}>
        <AutorenewIcon color="primary"/>
      </IconButton>
    </Box>
  )
}

const useStyles = makeStyles(theme => ({
  root: {
    gap: "13px",
    display: "flex",
    padding: "0 16px",
    alignItems: "center",
    boxSizing: "border-box",
  },
  title: {
    fontSize: 14,
    color: "#566B7D",
    fontWeight: "500",
    lineHeight: "16px",
  },
  count: {
    fontSize: 14,
    color: "#323232",
    fontWeight: "600",
    lineHeight: "16px",
  },
  button: {
    background: "white",
    borderRadius: "10px",
    boxShadow: "0px 4px 16px -4px #3A37A624",
  },
}));

export default TableTotalCount
